import { isCloud } from '@blk/aw-env-detection';
import { HeaderRequestId } from '../../utils/HeaderUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { awApi } from './Base';

/*
 * TODO: create a aw-types package and move all types there - this is a copy paste of
 * packages/aw-utils/src/logger/Models.ts
 */
export interface GenStatV2 {
  attrib1?: string;

  attrib2?: string;
  // The rest are optional
  data1?: number;
  data2?: number;
  data3?: number;
  data4?: number;
  data5?: number;
  data6?: number;
  data7?: number;
  data8?: number;
  key2?: string;
  key3?: string;
  key4?: string;
  key5?: string;
  metadata?: { [index: string]: string | boolean };
  // submodule is always required
  subModule: string;
  tagDef?: string;
}

export interface LogPayload extends GenStatV2 {
  [HeaderRequestId.NAME]: string;
  asOfDate: number;
  date1: number;
  endDate: number;
}

export function postGenStat(payload: LogPayload, headerRequestId: HeaderRequestId) {
  if (isCloud() || isAGraphEnabled()) {
    // No GenStat on cloud environments or if AGraph is enabled for AladdinWealthServer
    return Promise.resolve();
  }
  const path = '/stats/v2';
  return awApi.post(path, payload, { headers: headerRequestId.toHeader() });
}
